/**
 * GENERATED FILE - DO NOT EDIT DIRECTLY
 * Generated from backend .env file during build process
 */

// API configuration
export const API_PORT = "3720";
export const API_HOST = "localhost";
export const API_PROTOCOL = "http";
export const API_BASE_URL = "https://automatrix.nucleos.com/api";
export const FRONTEND_URL = "https://automatrix.nucleos.com";

// Auth configuration
export const AUTH_BASE_URL = "https://automatrix.nucleos.com";

// Feature flags
export const ENABLE_MOCK_DATA = false;

// Other configuration settings
export const DEFAULT_PAGINATION_LIMIT = 10;
export const MAX_AUTOMATION_NAME_LENGTH = 50;
